import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRComponent } from './simple-icons-r.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRComponent ],
    exports:      [ SimpleIconsRComponent ],
    bootstrap:    []
})
export class SimpleIconsRModule {}
